import _ from 'lodash';
import React, { useMemo, useRef, useState } from "react";
import { generateClient } from '@aws-amplify/api';
import { getAIPlatforms as _getAIPlatforms } from '@/graphql/queries';
import { upsertAIPlatform as _upsertAIPlatform } from '@/graphql/mutations';
import HeaderWithTabs from '@/HeaderWithTabs'
import ErrorModal from '@/ErrorModal';
import Breadcrumb from '@/Breadcrumb';
import { selectField, textAreaField, textField } from '@/commonFields';
import useFormFields from '@/hooks/useFormFields';
import { statuses } from './enums';

const client = generateClient();

const getObject = ({ ai_platform }) => {
	return client.graphql({ query: _getAIPlatforms, variables: { ai_platform } })
		.then(response => {
			const data = response.data.getAIPlatforms.ai_platforms?.[0];
			return data;
		});
};

const upsertObject = ({ input }) => {
	return client.graphql({ query: _upsertAIPlatform, variables: { input } })
		.then(response => {
			return response.data.upsertAIPlatform;
		});
};

export default ({ createLabel = 'Create', links = [], onCancel, onSave, updateLabel = 'Save' }) => {
	const {
		origModel,
		model,
		setModel,
		changeModel,
		deleteModel,
		jsonModel,
		errors,
		setErrors,
		hasValue,
		getError,
		get_value,
		set_value,
		get_array,
		set_array,
		add_array,
		remove_array,
		id,
		isCreate,
		sanitizeObject
	} = useFormFields();

	const isConstructed = useRef(false);
	const [errorMessage, setErrorMessage] = useState();
	const [isLoaded, setIsLoaded] = useState(isCreate);
	const [isSaving, setIsSaving] = useState(false);
	const isEqual = _.isEqualWith(sanitizeObject(model), origModel.current);
	const [file, setFile] = useState(null);

	const catchError = error => {
		if (error instanceof Error) {
			setErrorMessage(error.toString());
		} else {
			setErrorMessage((error.errors || []).map(e => e.message?.toString()));
		}
		setIsLoaded(true);
		setIsSaving(false);
	};

	if (!isConstructed.current) {
		isConstructed.current = true;
		if (!isLoaded) {
			getObject({ ai_platform: id })
				.then(data => {
					origModel.current = { ai_platforms: data };
					setModel({ ai_platforms: data });
					setIsLoaded(true);
				})
				.catch(catchError);
		} else {
			setModel({
				ai_platforms: { status: 'Healthy' }
			});
		}
	}

	const details = useMemo(() => (
		<div className="row mt-5">
			<div className="col-8">
				<div className="border shadow p-3 bg-form">
					<div className="row">
						<div className="col">
							{textField({ autoFocus: isCreate, get: get_value, getError, set: set_value, key: 'ai_platforms', label: 'AI Platform', name: 'ai_platform' })}
						</div>
						<div className="col-3">
							{selectField({ get: get_value, getError, set: set_value, key: 'ai_platforms', label: 'Status', name: 'status', options: statuses })}
						</div>
					</div>
				</div>
			</div>
		</div>
	), [JSON.stringify(errors), JSON.stringify(model)]);

	const tabs = [
		{ name: 'details', label: 'Details', content: details }
	];

	const handleSave = () => {
		// Extract input from model
		const input = {
			...changeModel.current,
			ai_platforms: {
				...changeModel.current.ai_platforms,
				// Forcing status on create so upsert is meaningful in this case
				...(!isCreate ? { ai_platform: id } : { status: model.ai_platforms.status })
			}
		};
		console.log('model', model);
		const newErrors = {
			ai_platforms: {}
		};
		if (!hasValue({ key: 'ai_platforms', name: 'ai_platform' })) {
			newErrors.ai_platforms.ai_platform = 'AI Platform is required';
		}
		// Clean out empties
		Object.keys(newErrors).forEach(e => {
			if (
				(Array.isArray(newErrors[e]) && newErrors[e].length === 0) ||
				Object.keys(newErrors[e]).length === 0
			) {
				delete newErrors[e];
			}
		});
		console.log('newErrors', newErrors);
		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors);
			return;
		}
		console.log('input', input);
		console.log('deleteModel', deleteModel.current);
		setIsSaving(true);
		upsertObject({ input, ...(deleteModel.current.length > 0 ? { input_delete: deleteModel.current } : undefined) })
			.then(response => {
				console.log('response', response);
				setIsSaving(false);
				onSave && onSave();
			})
			.catch(catchError);
	};

	const handleCancel = () => onCancel && onCancel();

return (
    <>
        {errorMessage && <ErrorModal message={errorMessage} onClose={() => setErrorMessage()} title="Error" />}
        <div className="container-fluid px-4 position-relative">
            <HeaderWithTabs
                isLoaded={isLoaded}
                path="/app/customers/"
                tabs={tabs} 
            > {isLoaded && (
                    <>
                        {links.length > 0 && <Breadcrumb className="mb-3 mx-3" links={links} />}
                        <div className="row align-items-center position-absolute py-1 me-5" style={{right:0, zIndex: 10}}>
                            <button 
                                className="col-auto ml-auto my-0 btn btn-primary" 
                                disabled={!((isCreate || !isEqual) && !isSaving)} 
                                onClick={handleSave}
                            >
                                {isCreate ? createLabel : updateLabel }
                            </button>
                            <a className="col-auto ms-2" role="button" onClick={handleCancel}>Cancel</a>
                        </div>
                        
                        {isSaving && (
                            <div className="text-center position-absolute" style={{height:'100%', left:0, top:0, width:'100%', zIndex:20, background: 'rgba(255,255,255,0.5)'}}>
                                <button className="btn btn-primary position-relative" style={{top:'40%'}} type="button" disabled>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    Saving...
                                </button>
                            </div>
                        )}
                    </>
                )}
            </HeaderWithTabs>
        </div>
    </>
);
};
